import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/client'
import FileUpload from './FileUpload'
import Modal from './Modal'
import { ImportForeign } from '../graphql/mutations'

const ImportForeignModal = ({
    show,
    close,
    onSuccess,
}) => {

    const { t } = useTranslation()
    const [error, setError] = useState()
    const [loading, setLoading] = useState(false)
    const [importForeign] = useMutation(ImportForeign)

    const handleImport = async (file) => {
        setLoading(false)
        
        try {
            const res = await importForeign({
                variables: {
                    file,
                },
            })

            if (res?.data?.importForeign?.code === 'SUCCESS') {
                if (onSuccess) onSuccess()
                return
            }

            if (res?.data?.importForeign?.items?.length > 0) {
                const failList = res.data.importForeign.items.map(x => `(${x.error}) Name: ${x.name}, Sum: ${x.sum}, PID: ${x.pid}`)
                setError(`${t('foreign.import_error')}\n\n${failList.join('\n\n')}`)
                return
            }

            setError(t('foreign.import_error'))
        } catch (err) {
            setError(t('foreign.import_error'))
            console.log(err)
        } finally {
            setLoading(false)
        }
    }

    const handleClose = () => {
        if (close) close()
        setError(null)
    }

    return (
        <Modal
            className={'modal-bonuses'}
            show={show}
            close={handleClose}
            title={ t('foreign.import') }
        >
            <FileUpload
                handleUpload={handleImport}
                loading={loading}
            />

            {
                error ?
                <div className='error-message'>
                    <span>{ error }</span>
                </div>
                :
                <></>
            }
        </Modal>
    )
}

export default ImportForeignModal